<template>
    <li
        class="nav-item dropdown"
        @click="toggleDropDown"
        v-click-outside="closeDropDown"
    >
        <a
            class="nav-link"
            href="#"
            role="button"
            data-toggle="dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i class="fa fa-coins"></i>
            <span>{{ currency.code }}</span>
        </a>
        <div
            class="dropdown-menu"
            :class="[{ show: isOpen }, { 'dropdown-menu-right': direction }]"
        >
            <div v-for="item in currencies" :key="item.id">
                <a
                    href="#!"
                    class="dropdown-item"
                    @click="changeCurrency(item)"
                >
                    <span>{{ item.code }}</span>
                </a>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'CurrencySelect',
    data() {
        return {
            isOpen: false,
        };
    },
    async mounted() {
        if (!this.currency) {
            await this.$store.dispatch('GET_SESSION_CURRENCY');
        }
        if (!this.currencies.length) {
            await this.$store.dispatch('INDEX_CURRENCIES');
        }
    },
    computed: {
        currencies() {
            return this.$store.getters.CURRENCIES;
        },
        currency() {
            return this.$store.getters.CURRENCY;
        },
        direction() {
            return !this.$store.getters.NAVBAR_POSITION;
        },
    },
    methods: {
        toggleDropDown() {
            this.isOpen = !this.isOpen;
        },
        closeDropDown() {
            this.isOpen = false;
            this.$emit('change', false);
        },
        changeCurrency(item) {
            if (item.code !== this.currency) {
                this.$emit('currency', item.code);
                this.$store.dispatch('CHANGE_CURRENCY', { code: item.code });
            }
        },
    },
};
</script>

<style>
.nch--flag-icon {
    vertical-align: 0 !important;
}
</style>
